export const FormSuccess = ({
  success,
}: {
  success: string | null | undefined;
}) => {
  if (!success) return null;

  return <div className="text-center text-success">{success}</div>;
};
